import React, { useState } from 'react'
import FAQItem from './FAQItem';
import faqs from './FAQsList';
import { isDemoEnabled } from '../../Utility/UserUtils'
import PortalSearchBar from '../Shared/PortalSearchBar'

const FAQs = () => {

    const [searching, setSearching] = useState('')
    const search = (e) => {
        setSearching(e.target.value)
    }
    const IsDemoFeatureEnabled = isDemoEnabled();

    const filteredFAQs = faqs.filter(faq =>
        faq.ques.toLowerCase().includes(searching.toLowerCase()) ||
        faq.ans.toLowerCase().includes(searching.toLowerCase())
    );

    return (
        <div className="content">
            <h1>Global Growth Cube – FAQs</h1>
            {/* <p className="faq-intro">
                Please refer to the below for frequently asked questions on Global Growth Cube. If any of your questions aren’t addressed, do not hesitate to reach out to one of our team members {(<a href="mailto:performancelens_growthcube@mckinsey.com">performancelens_growthcube@mckinsey.com</a>)} who would be more than happy to assist you.
            </p> */}
            <PortalSearchBar
                value={searching}
                onChange={search}
                placeholder="Search FAQs"
            />
            <br /><br />
            {/* <h1>General questions</h1> */}

            {filteredFAQs.map(faq => (
                <FAQItem key={faq.id} faq={faq} searchTerm={searching} />
            ))}
        </div>
    )
}

export default FAQs